import dynamic from "next/dynamic";
import QueryString from "qs";
import { GetServerSideProps, NextPage } from "next";
const IndustryPage = dynamic(() => import("@/Components/pages/Industries"), {
  ssr: true,
});

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59"
    );
  }
  const slug = ctx?.params?.slug ?? "";
  const userAgent = ctx.req.headers["user-agent"] || "";
  const isMobile =
    /iphone|ipod|android.*mobile|blackberry|iemobile|opera mini/i.test(
      userAgent
    );
  let apiRes = null;
  let apiResData = null;
  let isNew = false;
  const query = QueryString.stringify(
    {
      publicationState: "preview",
      filters: {
        slug: {
          $eq: slug,
        },
        publishedAt: {
          $null: true,
        },
      },
      populate: "deep, 6",
    },
    {
      encodeValuesOnly: false,
    }
  );
  apiRes = await fetch(`${baseUrl}industries?${decodeURIComponent(query)}`);
  apiResData = await apiRes.json();
  isNew = apiResData.data[0].attributes.design === "new";
  return {
    props: {
      apiResData,
      slug,
      isNew,
      isMobile,
    },
  };
};

interface IndustryProps {
  apiResData: any;
  slug: string;
  status: number;
  isNew: boolean;
  isMobile: boolean;
}

const Industry: NextPage<IndustryProps> = ({ apiResData, isMobile }) => {
  const listData = apiResData?.data[0].attributes || [];
  const blocksData = listData.blocks;
  const seoData = listData.seo[0] || null;
  const breadcrumbs = listData.breadcrumbs;

  return (
    <IndustryPage
      blocks={blocksData}
      isMobile={isMobile}
      seo={seoData}
      breadcrumbs={breadcrumbs}
    />
  );
};

export default Industry;
